import styled from 'styled-components';

import { AFFILIATE_FORM, AFFILIATE_FORM_ANIM, COLORS } from '../../theme/tokens';
import { contentAreaOverlay } from '../../theme/contentAreaOverlay';
import { Text } from '../Text/Text';

/**
 * Backdrop dim. On desktop it is re-pinned to the MainLayout content card
 * (`contentAreaOverlay`) so the dialog centres within the card, not the
 * off-centre viewport. z-index sits on the area's documented ladder: modal
 * backdrop 2000 < Toast 2100 (a confirmation toast is never occluded).
 */
export const Backdrop = styled.div<{ $on: boolean }>`
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: ${AFFILIATE_FORM.backdrop};
  opacity: ${(p) => (p.$on ? 1 : 0)};
  /* Inert during the exit animation: the invisible footer buttons must not
     accept clicks (a double-click on a confirm would re-fire the action). */
  pointer-events: ${(p) => (p.$on ? 'auto' : 'none')};
  transition: opacity ${AFFILIATE_FORM_ANIM.BACKDROP_MS}ms ${AFFILIATE_FORM_ANIM.EASE};

  ${contentAreaOverlay}
`;

/** The dialog surface: the studio modal kit (AFFILIATE_FORM surface + shadow). */
export const Dialog = styled.div<{ $on: boolean }>`
  width: min(440px, 100%);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  border-radius: 16px;
  border: 1px solid ${COLORS.panelBorder};
  background: ${AFFILIATE_FORM.surface};
  box-shadow: ${AFFILIATE_FORM.modalShadow};
  opacity: ${(p) => (p.$on ? 1 : 0)};
  transform: ${(p) => (p.$on ? 'none' : 'translateY(10px) scale(0.98)')};
  transition:
    opacity ${AFFILIATE_FORM_ANIM.SHEET_MS}ms ${AFFILIATE_FORM_ANIM.EASE},
    transform ${AFFILIATE_FORM_ANIM.SHEET_MS}ms ${AFFILIATE_FORM_ANIM.EASE};
  outline: none;
`;

export const Head = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

export const Title = styled(Text)`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.3;
  color: ${COLORS.heading};
  margin: 0;
`;

export const CloseButton = styled.button`
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  flex: 0 0 auto;
  border: none;
  border-radius: 99px;
  background: transparent;
  color: ${COLORS.icon};
  cursor: pointer;

  &:hover {
    background: ${COLORS.surfaceMuted};
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;
